export const API_URL_FACTORY = {
  PUC_API: (regNo: string) => `/api/app/puc/?regNo=${regNo}`,
  VEHICLE_INFO_API: (regNo: string) => `/api/app/vehicleInfo/?regNo=${regNo}`,
  DEPP_LINK_API: (regNo: string, widgetType: string, utmLead: string, mobileNo: string) => `/api/app/deepLink/?regNo=${regNo}&widgetType=${widgetType}&utmLead=${utmLead}&mobileNo=${mobileNo}`,
  PUC_FETCH: (pucService: string, regNo: string | null) => `${pucService}/vas/api/v1/pucs?registration-number=${regNo}`,
}
